import universalLocalStorage from "../utils/lib/universalLocalStorage.js";

export default async function getUserID() {
  let data = await universalLocalStorage.getItem("wellness-userID");
  return data;
}
